var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.shouldShowBanner)?_c('div',{staticClass:"message-banner"},[_c('p',{staticClass:"message-banner__header"},[_vm._v(_vm._s(_vm.header))]),_vm._v(" "),_c('p',{staticClass:"message-banner__text"},[_vm._v(_vm._s(_vm.message))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }